module.exports = __webpack_public_path__ + "static/media/whatsapp-logo.8b47f833.svg";